export default "__VITE_ASSET__e8f478f1__"